export const getAppName = () => {
  return (
    process.env.REACT_APP_BUILD_TARGET ? process.env.REACT_APP_BUILD_TARGET : 'App Name'
  );
};